import { memoize } from "@/fp";

export const create_carousel = (count: number, arr: any[][]) => {
  let index = count;
  return {
    next: () => {
      const res = arr[index % count];
      index++;
      return res;
    },
  };
};

export const uniq_id = (() => {
  let id = 1;
  return () => ++id;
})();

const LOREM_100 = `Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laboriosam debitis cumque enim quaerat deleniti, eveniet tenetur neque ipsa ex ipsum perferendis qui iusto eaque maiores quis quo ducimus veritatis et animi tempore! Error earum omnis labore nisi debitis! Dicta, laudantium! Asperiores sed dolorum deserunt vitae perferendis magni ab accusamus adipisci ipsum distinctio velit facilis, aperiam atque ipsa praesentium id perspiciatis possimus vel assumenda. Unde error expedita dolore asperiores. Porro aspernatur recusandae aliquid corrupti et ipsam earum vero, consectetur impedit, tempore laboriosam iure excepturi eius! Rerum autem sed id dolores placeat dolore atque, earum qui accusamus reiciendis numquam optio expedita sit.`.split(
  " "
);
export const lorem_ipsum = memoize((word_count: number) => {
  return LOREM_100.slice(0, word_count).join(" ");
});
